import { render, staticRenderFns } from "./UiModal.vue?vue&type=template&id=312017e3&scoped=true"
import script from "./UiModal.vue?vue&type=script&lang=js"
export * from "./UiModal.vue?vue&type=script&lang=js"
import style0 from "./UiModal.vue?vue&type=style&index=0&id=312017e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312017e3",
  null
  
)

export default component.exports